import { render, staticRenderFns } from "./ExperienceLevelOptions.vue?vue&type=template&id=2b3afa8c&scoped=true"
import script from "./experienceLevelOptions.ts?vue&type=script&lang=ts&external"
export * from "./experienceLevelOptions.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3afa8c",
  null
  
)

export default component.exports